import { Markup } from '@dav-model/login/response/user.response.model';
import { ProductFilters } from '@dav-model/product-filters/product-filters';
import { GetProductsRequest } from '@dav-model/request/product.request';
import { GetProductsResponse, ProductItem } from '@dav-model/response/getproducts.response';
import { SurchargeSelectionState } from '@dav-model/surcharge-selection-state.model';
import { Action } from '@ngrx/store';

// ACTION TYPES
export const GET_PRODUCTS = '[PRODUCT] GET PRODUCTS';
export const GET_PRODUCTS_SUCCESS = '[PRODUCT] GET PRODUCTS SUCCESS';
export const GET_PRODUCTS_FAILURE = '[PRODUCT] Get PRODUCTS FAILURE';
export const FILTER_GRID = '[PRODUCT] FILTER GRID';
export const FILTER_GRID_SUCCESS = '[PRODUCT] FILTER GRID SUCCESS';
export const SORT_GRID = '[PRODUCT] SORT GRID';
export const RESET_PRODUCTS = '[PRODUCT] RESET PRODUCTS';
export const LOAD_PRODUCT_QUOTE = '[PRODUCT] LOAD PRODUCT QUOTE';
export const ADD_MARKUP_TO_COST = '[PRODUCT] ADD MARKUP TO COST';
export const CHANGE_MARKUP = '[PRODUCT] CHANGE MARKUP';
export const APPLY_SURCHARGES = '[PRODUCT] APPLY SURCHARGES';
export const SET_SURCHARGES_SELECTION = '[PRODUCT] SET SURCHARGES SELECTION';
export const RESET_SURCHARGES_SELECTION = '[PRODUCT] RESET SURCHARGES SELECTION';

export class GetProducts implements Action {
  readonly type = GET_PRODUCTS;

  constructor(public payload: GetProductsRequest) {
  }
}

export class ChangeMarkupAction implements Action {
  readonly type = CHANGE_MARKUP;

  constructor(public payload: Markup) {
  }
}

export class AddMarkupToCostAction implements Action {
  readonly type = ADD_MARKUP_TO_COST;

  constructor(public payload: { markup: Markup; grid: ProductItem[] }) {
  }
}

export class GetProductsSuccess implements Action {
  readonly type = GET_PRODUCTS_SUCCESS;

  constructor(
    public payload: {
      response: GetProductsResponse;
      gridProducts: ProductItem[];
      filters: ProductFilters;
      markup: Markup;
    }
  ) {
  }
}

export class GetProductsFailure implements Action {
  readonly type = GET_PRODUCTS_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class FilterGridAction implements Action {
  readonly type = FILTER_GRID;

  constructor(public payload: ProductFilters) {
  }
}

export class FilterGridSuccessAction implements Action {
  readonly type = FILTER_GRID_SUCCESS;

  constructor(public payload: { filters: ProductFilters; grid: ProductItem[] }) {
  }
}

export class SortGridAction implements Action {
  readonly type = SORT_GRID;

  constructor(public payload: ProductItem[]) {
  }
}

export class LoadProductQuoteAction implements Action {
  readonly type = LOAD_PRODUCT_QUOTE;

  constructor(
    public payload: {
      request: GetProductsRequest;
      response: GetProductsResponse;
      gridProducts: ProductItem[];
      filters: ProductFilters;
      markup: Markup;
    }
  ) {
  }
}

export class ResetProductsAction implements Action {
  readonly type = RESET_PRODUCTS;
}

export class ApplySurchargesAction implements Action {
  readonly type = APPLY_SURCHARGES;
}

export class ResetSurchargesSelectionAction implements Action {
  readonly type = RESET_SURCHARGES_SELECTION;
}

export class SetSurchargesSelectionAction implements Action {
  readonly type = SET_SURCHARGES_SELECTION;

  constructor(public surchargesSelection: SurchargeSelectionState[]) {
  }
}

export type All =
  | GetProducts
  | GetProductsSuccess
  | GetProductsFailure
  | ResetProductsAction
  | FilterGridAction
  | FilterGridSuccessAction
  | SortGridAction
  | LoadProductQuoteAction
  | AddMarkupToCostAction
  | ChangeMarkupAction
  | ApplySurchargesAction
  | ResetSurchargesSelectionAction
  | SetSurchargesSelectionAction;
